import DocumentImporterConfiguration from "./services/model/DocumentImporterConfiguration";
import {
  SupportedDocumentAttributes,
  SupportedFeatures,
} from "./services/model/FeatureConfiguration";

export const payslipJourneyConfiguration: DocumentImporterConfiguration = {
  document_type: SupportedFeatures.PAYSLIPS,
  document_name: "Payslip",
  document_name_lower_case: "payslip",
  document_name_plural: "Payslips",
  document_name_plural_lower_case: "payslips",
  main_page_route: "",
  attributes: [
    SupportedDocumentAttributes.BATCH_NAME,
    SupportedDocumentAttributes.ISSUE_DATE,
    SupportedDocumentAttributes.DISTRIBUTION_DATES,
  ],
};
